<template>
    <div>
        <div class="c-t-request__main" v-if="loading && !error" key="loading">
            <loader class="c-m-loader--x-large" />
        </div>
        <div class="c-t-company__main" v-else-if="error">
            <error-state />
        </div>

        <div v-if="!error && !loading">
            <div v-if="!confirmView">
                <h2>Vad kul att du valt hantverkare!</h2>

                <p>
                    Kom ihåg att du bara kan välja ett företag att skriva avtal
                    med. Hantverkaren du väljer kommer att fylla i ett förslag
                    på avtal och du får ett mail så fort det finns att läsa. När
                    ni är överens om innehållet i avtalet signerar du och
                    hantverkaren enkelt med BankID, allt för er bådas trygghet.
                </p>

                <atom-select
                    :alternatives="companies"
                    v-model="selectCompany"
                    :label="'Välj hantverkare:'"
                    :id="'company'"
                    :class="{ 'c-a-select--invalid': invalid }"
                    :placeholder="'Välj ett företag'"
                />

                <atom-button
                    :label="'Be om avtalsförslag'"
                    class="c-a-button--theme-secondary request-contract-button"
                    @buttonClicked="validate()"
                />
            </div>
            <div v-else>
                <h2>
                    Be om avtalsförslag från <br /><b>{{
                        chosenContractorName
                    }}</b>
                </h2>

                <p>
                    Är du säker på att du vill ha ett avtalsförslag från
                    <b>{{ chosenContractorName }}</b
                    >?
                </p>

                <button-group class="no-print u-margin-top-6">
                    <atom-button
                        v-if="request.IsOwner"
                        label="Tillbaka"
                        class="c-a-button--theme-white"
                        @buttonClicked="confirmView = false"
                    />
                    <atom-button
                        label="Ja, jag vill ha ett avtalsförslag"
                        class="c-a-button--theme-primary"
                        @buttonClicked="submit"
                    ></atom-button>
                </button-group>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
    GET_ERROR,
    IS_LOADING,
    SEND_CONTRACT_REQUEST
} from "../../../store/store-models/contract-model";

import AtomButton from "../atoms/AtomButton.vue";
import AtomSelect from "../atoms/form/AtomSelect.vue";
import ButtonGroup from "../molecules/MoleculeButtonGroup";

import ErrorState from "../molecules/MoleculeErrorState.vue";
import Loader from "../molecules/MoleculeLoader.vue";

export default {
    components: {
        AtomButton,
        AtomSelect,
        ButtonGroup,
        Loader,
        ErrorState
    },
    props: {
        request: {
            default: {},
            type: Object
        },
        companies: {
            default: [],
            type: Array
        }
    },
    data() {
        return {
            confirmView: false,
            chosenContractorId: null,
            chosenContractorName: null,
            chosenContractorContactId: null,
            invalid: false
        };
    },
    computed: {
        ...mapGetters({
            error: GET_ERROR,
            loading: IS_LOADING
        }),
        selectCompany: {
            get() {
                return this.chosenContractorId;
            },
            set(value) {
                let company = this.request.Companies.find(x => {
                    return x.CompanyId === value;
                });
                this.chosenContractorName = company.CompanyName;
                this.chosenContractorContactId = company.ContactId;
                this.chosenContractorId = value;
            }
        }
    },
    methods: {
        ...mapActions({
            sendContractRequest: SEND_CONTRACT_REQUEST
        }),
        async submit() {
            await this.sendContractRequest({
                requestId: this.request.Id,
                ContractorContactId: this.chosenContractorContactId
            });
            if (!this.error) this.$emit("completed");
        },
        validate() {
            if (!this.chosenContractorId) this.invalid = true;
            else {
                this.confirmView = true;
                this.invalid = false;
            }
        }
    }
};
</script>

<style scoped>
.request-contract-button {
    margin-top: 1em;
}
</style>



// WEBPACK FOOTER //
// src/views/components/organisms/OrganismContractForm.vue